/* eslint-disable react-hooks/rules-of-hooks */
import React, { useState, useEffect } from 'react';
import leftArrow from '../../assets/images/model/left-arrow.png';
import rightArrow from '../../assets/images/model/right-arrow.png';
import bold from '../../assets/images/model/bold.png';
import italic from '../../assets/images/model/italic.png';
import underline from '../../assets/images/model/underline.png';
import link from '../../assets/images/model//link.png';
import bulletList from '../../assets/images/model/bullet_list.png';
import numberedList from '../../assets/images/model/numbered_list.png';
import search from '../../assets/images/model/search.png';
import easyRead from '../../assets/images/model/Easy_read_mode.png';
import fontSize from '../../assets/images/model/font_size.png';
import { Dropdown } from 'react-bootstrap';
import help from '../../assets/images/model/help.png';
import dashboard from '../../assets/images/model/dashboard.png';
import bell from '../../assets/images/model/bell.png';
import menu from '../../assets/images/model/menu.png';
import storage from '../../services/storage';
import { resetAuth } from '../../Store/auth/authReducer';
import '../../Pages/Book/createbook.css';
import '../../Pages/Book/createbookresponsive.css';
import { SelectOption } from '../../Pages/Book/models/SelectOption';
import { Link, useNavigate, useSearchParams } from 'react-router-dom';
import { useDispatch, useSelector } from 'react-redux';
import { CustomDropDown } from '../../shared/CustomDropDown';

const fontFamilies = [{ value: 'Inter, sans-serif', label: 'Inter' }];

const fontSizes = [{ value: 3, label: '100%' }];

const GreyledHeader = () => {
  const [params] = useSearchParams();
  const queryParam = params.get('openModel');

  const books = useSelector((state) => state.entities.books.all);
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const [isActive, setIsActive] = useState(false);
  const toggleActive = () => {
    setIsActive(!isActive);
  };
  const [isSearchActive, setIsSearchActive] = useState(false);
  const [selectOption, setSelectOption] = useState(queryParam || false);

  const toggleSearch = () => {
    setIsSearchActive(!isSearchActive);
  };

  const { user, token } = useSelector((state) => state.auth);

  const logout = (e) => {
    e.preventDefault();
    storage.remove('xAuthToken');
    storage.remove('user');
    storage.remove('sectionId');
    storage.remove('lastBookId');
    storage.remove('searchParams');
    storage.remove('class');
    storage.remove('status');
    dispatch(resetAuth());
    // window.location.reload();
    setTimeout(() => {
      navigate('/', { replace: true, state: { fromState: 'student' } });
    }, 500);
    // navigate("/");
  };

  return (
    <>
      <div className='top_header_inner_create' style={{ width: '100%' }}>
        <div
          className={`top_header_edit_option_create ${isSearchActive ? 'active' : ''}`}
          style={{ width: '60%' }}
        >
          {/* <TextEditorFun /> */}
          <div className='edit_list_create ' style={{ width: '100%' }}>
            <ul className='create_ul'>
              <li>
                <button disabled className='tool-button' style={{ padding: '4px' }}>
                  <img src={leftArrow} alt='left-arrow' />
                </button>
              </li>
              <li style={{ margin: '0px' }}>
                <button disabled className='tool-button' style={{ padding: '4px' }}>
                  <img src={rightArrow} alt='right-arrow' />
                </button>
              </li>
              <li>
                <div style={{ display: 'flex', alignItems: 'center' }}>
                  <CustomDropDown
                    options={fontSizes}
                    handleClick={() => {}}
                    selectedValue={fontSizes[0].value}
                    style={{ padding: '6px 0px', textAlign: 'center' }}
                  />

                  <CustomDropDown
                    options={fontFamilies}
                    style={{ padding: '12px' }}
                    handleClick={() => {}}
                    selectedValue={fontFamilies[0].value}
                    className='select-font-family-container'
                    dropdownButtonClassName='select-align-options-button'
                  />
                </div>
              </li>

              <div className='header_right_side_container' style={{ gap: '0px' }}>
                <li style={{ margin: '0px 8px' }}>
                  <button disabled className='tool-button' style={{ padding: '4px' }}>
                    <img src={bold} alt='bold-arrow' />
                  </button>
                </li>
                <li style={{ margin: '0px 8px' }}>
                  <button disabled className='tool-button' style={{ padding: '4px' }}>
                    <img src={italic} alt='italic' />
                  </button>
                </li>
                <li style={{ margin: '0px 8px' }}>
                  <button disabled className='tool-button' style={{ padding: '4px' }}>
                    <img src={underline} alt='underline' />
                  </button>
                </li>
                <li>
                  <button disabled className='tool-button' style={{ padding: '4px' }}>
                    <img src={link} alt='link' />
                  </button>
                </li>
                <li style={{ margin: '0px 8px' }}>
                  <button disabled className='tool-button' style={{ padding: '4px' }}>
                    <img src={bulletList} alt='bullet_list' />
                  </button>
                </li>
                <li style={{ margin: '0px 8px' }}>
                  <button disabled className='tool-button' style={{ padding: '4px' }}>
                    <img src={numberedList} alt='numbered_list' />
                  </button>
                </li>
              </div>
            </ul>
          </div>
          <div className='search_box_create'>
            <div className={`search_inner ${isSearchActive ? 'active' : ''}`}>
              <div className='input_wrap_search_create'>
                <input
                  type='search'
                  className='form-control search_input_create'
                  placeholder='Search in book'
                />
              </div>
              <button type='button' className='search_btn_create' onClick={toggleSearch}>
                <img src={search} alt='search' />
              </button>
            </div>
          </div>
        </div>
        <div
          className='rigt_list_top'
          style={{
            width: '39%',
            height: '40px',
            alignItems: 'center',
            display: 'flex',
          }}
        >
          <div className='edit_list_create' style={{ width: '100%' }}>
            <ul className='create_ul' style={{ gap: '10px' }}>
              <div
                className='header_right_side_container'
                style={{
                  gap: '0px',
                  width: '20%',
                  justifyContent: 'flex-start',
                }}
              >
                <li>
                  <a>
                    <img src={easyRead} alt='Easy_read_mode' />
                  </a>
                </li>
                <li style={{ margin: '0px' }}>
                  <a href='https://docs.greyled.com' target='__blank'>
                    <img src={help} alt='help' />
                  </a>
                </li>
              </div>
              <li className='w-280' style={{ margin: '0px', width: '50%' }}>
                <div className='select_option'>
                  <div
                    onClick={toggleActive}
                    className={`select_wrap_create custom_option_create custom_select_create ${
                      isActive ? 'active' : ''
                    }`}
                    style={{ width: '100%' }}
                  >
                    <p className='main_text mb-0'>Book Select</p>
                    <div className='select_option_inner_cr' style={{ width: '100.7%' }}>
                      <p>Choose which book to edit</p>
                      <div className='list-class'>
                        <ul className='option_list_create'>
                          {books.map((book) => (
                            <li
                              style={{
                                margin: '0px',
                                paddingLeft: '0px',
                                paddingRight: '0px',
                              }}
                              className='list-book cursor'
                              onClick={(e) => {
                                navigate(`/create/${book._id}`);
                              }}
                            >
                              {book.title}
                            </li>
                          ))}
                        </ul>
                      </div>

                      <button
                        style={{ bottom: '8px' }}
                        type='button'
                        className='btn-black_create'
                        onClick={() => setSelectOption(true)}
                      >
                        Create Book
                      </button>
                    </div>
                  </div>
                </div>
              </li>
              <div className='header_right_side_container' style={{ width: '30%' }}>
                <li className='cursor' style={{ margin: '0 5px' }}>
                  <Link className='cursor text-decoration-none' to='/dashboard'>
                    <img src={dashboard} alt='dashboard' />
                  </Link>
                </li>
                <li style={{ margin: '0px' }}>
                  <img src={bell} alt='bell' className='cursor' />
                </li>
                <li className='cursor' style={{ margin: '0 5px' }}>
                  <Dropdown className='cursor'>
                    <Dropdown.Toggle
                      as={React.forwardRef(({ children, onClick }, ref) => (
                        // eslint-disabled-next-line jsx-a11y/anchor-is-valid
                        <a
                          ref={ref}
                          onClick={(e) => {
                            e.preventDefault();
                            onClick(e);
                          }}
                        >
                          {user?.image ? (
                            <img src={user?.image} className='user_img_cre' alt='profile_photo' />
                          ) : (
                            <div className='profilePicture' style={{ fontSize: '16px' }}>
                              {user?.firstName?.[0]}
                              {user?.lastName?.[0]}
                            </div>
                          )}
                        </a>
                      ))}
                      id='dropdown-custom-components dropdown-button-drop-left'
                    />
                    <Dropdown.Menu>
                      <Dropdown.Item onClick={() => navigate('/dashboard/settings')}>
                        {user.firstName} {user.lastName}
                      </Dropdown.Item>

                      <Dropdown.Item onClick={logout}>Signout</Dropdown.Item>
                    </Dropdown.Menu>
                  </Dropdown>
                </li>
              </div>
              <li className='menu_icon'>
                <a href='' className='menu_btn'>
                  <img src={menu} alt='numbered_list' />
                </a>
              </li>
            </ul>
          </div>
        </div>
      </div>
      <SelectOption selectOption={selectOption} setSelectOption={setSelectOption} />
    </>
  );
};

export default GreyledHeader;
